import { ActionBase } from '../../../core/store/action/ActionBase';

export const REPOROCESS_JOB_SUBMISSION = '[Submission] Reprocess Job Submission';

export class ReprocessJobSubmissionAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = REPOROCESS_JOB_SUBMISSION;

  constructor(public payload: { jobKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/ReprocessJobSubmissionAction.ts